<template>
  <div>
    <el-container>
      <el-main>
        <el-form :inline="true" size="small">
          <el-form-item>
            <el-input v-model="queryParams.accountName" placeholder="账户名" />
          </el-form-item>
          <el-form-item>
            <el-select v-model="queryParams.status" placeholder="提取状态">
              <el-option :value="0" label="待审核" />
              <el-option :value="1" label="通过" />
              <el-option :value="2" label="驳回" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-date-picker v-model="queryParams.createTime" type="datetime" placeholder="申请时间" @change="dataSearchSt" value-format="yyyy-MM-dd" format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-date-picker v-model="queryParams.updateTime" type="datetime" placeholder="返佣" @change="dataSearchEd" value-format="yyyy-MM-dd" format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-button size="small" plain @click="list(1)" type="primary"  icon="el-icon-search">搜索</el-button>
        </el-form>



        <el-table ref="multipleTable" :data="tableData" border height="550"
                  :row-style="{height:'40px',textAlign:'center'}" :cell-style="{height:'5px,0',textAlign:'center'}"
                  :header-cell-style="{background: '#f5f7fa', color: '#606266',textAlign:'center'}"
                  style="margin-top: 1%;height: 70vh">
          <el-table-column type="selection" width="55">
          </el-table-column>
          <el-table-column prop="agentId" label="代理商Id" width="150">
          </el-table-column>
          <el-table-column prop="accountName" label="账户名" width="100">
          </el-table-column>
          <el-table-column prop="account" label="收款账户">
          </el-table-column>

          <el-table-column prop="money" label="提现金额">
          </el-table-column>
          <el-table-column prop="arrival" label="到账金额">
          </el-table-column>
          <el-table-column prop="createTime" label="申请时间" width="180">
          </el-table-column>

          <el-table-column prop="status" label="提取状态">
            <template slot-scope="scope">
              <div v-if="scope.row.status===0">待审核</div>
              <div v-if="scope.row.status===1">已通过</div>
              <div v-if="scope.row.status===2">已驳回</div>
            </template>
          </el-table-column>
          <el-table-column prop="giveOut" label="是否到账">
            <template slot-scope="scope">
              <div v-if="scope.row.giveOut===0">未到账</div>
              <div v-if="scope.row.giveOut===1">已到账</div>
            </template>
          </el-table-column>
          <el-table-column prop="updateTime" label="到账时间" width="180">
          </el-table-column>
          <el-table-column prop="upUser" label="处理人">
          </el-table-column>
          <el-table-column prop="info" label="备注">
          </el-table-column>

        </el-table>
        <pagination class="text-center" ref="pagination" v-bind:list="list" v-bind:itemCount="8"></pagination>

      </el-main>
    </el-container>
  </div>
</template>

<script>
import Pagination from '../../../components/pagination'

export default {
  name: 'drawList',
  components: {
    Pagination
  },

  mounted: function () {
  },

  data() {
    return {
      maxHeight: 500,
      tableData:[],
      queryParams:{
        current:1,
        size: 10,
        accountName:'',
        status:'',
        createTime:'',
        updateTime:'',
      },
      agentJs: require('../../../api/profit'),
    }
  },

  methods: {

    dataSearchSt(data) {
      let that=this
      that.queryParams.createTime=data
    },
    dataSearchEd(data) {
      let that=this
      that.queryParams.updateTime=data
    },


    list(page) {
      let _this = this
      _this.loading=true
      _this.maxHeight = _this.$listenHeight.getBodyHeight()
      _this.queryParams.current = page
      _this.queryParams.size =_this.$refs.pagination.size

      _this.agentJs.getAgentSysCashOutList(_this.queryParams)
              .then(response => {
                _this.tableData = response.data.data.rows
                _this.$refs.pagination.render(page, response.data.data.total)
              })
    }
  }
}
</script>

<style scoped lang="less">

  /* 设置滚动条宽度和高度 */
  ::v-deep .el-table__body-wrapper::-webkit-scrollbar {
    width: 10px; /* 横向滚动条 */
    height: 10px; /* 纵向滚动条 必写 */
  }
  /* 设置滚动条样式 */
  ::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: #dde;
    border-radius: 3px;
  }
  ::v-deep .el-table {
    height: 88%;
    .el-table__body-wrapper {
      height: calc(100% - 48px) !important; // 表格高度减去表头的高度
      overflow-y: auto;
    }
  }

._select {
  width: 20%;
  height: 34px;
}
.pup {
  float: right;
}
.col-md-3 {
  float: left;
}
.el-input--small .el-input__inner {
  height: 32px;
  line-height: 3px !important;
}
</style>
<style scoped>
/deep/.el-table .el-table__cell {
  padding: 0px;
}
/deep/thead.has-gutter {
  height: 40px;
}

</style>